import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d289ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "some-padding" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_4 = { class: "form-dynamic-row form-group-col-3" }
const _hoisted_5 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_6 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_7 = { class: "operations-wrap" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(!_ctx.patient_id ? "Cadastro " : "") + "Paciente", 1),
    _createVNode(_component_Form, { class: "form-wrap" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_text_field, {
            modelValue: _ctx.body.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body.name) = $event)),
            name: 'name',
            label: 'Nome',
            validators: { required: {} },
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_date_picker, {
            name: 'scheduled_day',
            label: 'Data de nascimento',
            modelValue: _ctx.body.birthdate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body.birthdate) = $event)),
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"]),
          _createVNode(_component_text_field, {
            name: 'phone',
            label: 'Telefone',
            modelValue: _ctx.body.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body.phone) = $event)),
            format: 'phone',
            validators: { required: {}, phone: {} },
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"]),
          _createVNode(_component_text_field, {
            modelValue: _ctx.body.cpf,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.body.cpf) = $event)),
            name: 'cpf',
            label: 'CPF',
            format: 'cpf',
            validators: { required: {}, cpf: {} },
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_field, {
            modelValue: _ctx.body.registration,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.body.registration) = $event)),
            name: 'matricula',
            label: 'Matrícula',
            format: 'matricula',
            validators: { required: {}, registration: {} },
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_field, {
            modelValue: _ctx.body.address,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.body.address) = $event)),
            name: 'address',
            label: 'Endereço',
            validators: {},
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: _normalizeClass({
          btn: true,
          'btn-update': !_ctx.isLoading && _ctx.isFormValid && !!_ctx.patient_id,
          'btn-new': !_ctx.isLoading && _ctx.isFormValid && !!!_ctx.patient_id,
        }),
        disabled: !_ctx.isFormValid || _ctx.isLoading,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
      }, " Salvar ", 10, _hoisted_8)
    ])
  ]))
}